export default {
    404: "Whoops 404!! The page is not available.",
    title_404: "Page you are trying to reach\n" +
        "                    is not available",
    btn_404: "Go back",
    profilePosition: "Vote",
    manageScreenQuestion: "Question",
    manageScreenLocation: "Location description",
    manageSetGeolocation: "Set geolocation",
    manageSetAsset: "Asset #",
    manageGeolocation: "Geolocation",
    manageUpdateBtn: "Update",
    manageLatitude: "Latitude",
    manageLongitude: "Longitude",
    manageGPSAccuracy: "GPS accuracy {v1}m",
    manageGPSLocation: "GPS location",
    manageGPSAllowText: "Please allow air-vote.com to fetch GPS location data from your phone",
    manageGPSAllowSubtitle: "* we will use it only when you visit this page to update question’s geolocation",
    manageGPSPopupLongDistance: "Your current GPS coordinates are far away from the previous sticker placement ({v1}m)",
    manageGPSPopupBadAccuracyAndLongDistance: "Your current GPS coordinates are far away from the previous sticker placement ({v1}m) and have poor accuracy ({v2}m)",
    manageGPSPopupBadAccuracy: "Your current GPS coordinates have poor accuracy ({v1}m)",
    manageGPSPopupSureNewCoords: "Are you sure to use new coordinates?",
    manageGPSPopupUseNewCoordsBtn: "Use new coordinates",
    manageGPSPopupChangeManuallyBtn: "Change manually",
    manageMapBtn: "Use this location",
    manageSaved: "Saved",
    manageCopiedToClipboard: "Copied to the clipboard",
    manageGPSUnableToFetchMsg: "We were unable to fetch gps location. Please try again",
    manageGPSUnavailable: "GPS location is unavailable. Please try again or contact our support team",
    manage_back_to_yard: "Back to yard",
    admin_RemoveItem: "Remove {v1}",
    admin_AddItem: "Add {v1}",
    admin_Admin: "Admin",
    admin_Owner: "Contact",
    admin_Client: "User",
    admin_Votes: "Votes",
    admin_Profiles: "Profiles",
    admin_Organizations: "Organizations",
    admin_showAllPlaces: "Show all places",
    admin_SaveRole: "Save role",
    admin_deleteRole: "Delete profile {v1} {v2}?",
    admin_deleteVote: "Delete vote for question \"{v1}\"?",
    admin_deletePlace: "Delete location \"{v1}\"?",
    admin_deleteOrganization: "Delete organization \"{v1}\"?",
    admin_deletePlaceWarning: "** All related votes will be removed **",
    admin_successMessageAddOwner: "Contact added",
    admin_successMessageAddPlace: "Location added",
    admin_successMessageRemoveOwner: "Owner removed",
    admin_successMessageRemovePlace: "Place removed",
    admin_successMessageRemoveVote: "Vote removed",
    admin_successMessageRemoveOrganization: "Organization removed",
    admin_successMessageSaveOrganization: "Organization saved",
    admin_successMessageChangeRole: "Role changed",
    admin_Stickers: "Stickers",
    admin_ChangeStatusToCancelled: "Change status to \"Cancelled\"?",
    admin_ChangeStatusToSent: "Change status to \"Sent\"?",
    admin_ChangeStatusToCompleted: "Change status to \"Completed\"?",
    admin_adminVotesShowAll: "Including our votes",
    admin_searchByName: "Search by name",
    admin_signInAs: "Sign in as: {v1}?",
    admin_ReturnToOriginalAccount: "Return to original account: {v1}?",
    admin_closeAccountRequests: "Close account requests",
    admin_landingQuestions: "Landing questions",
    admin_firstName: "First name",
    admin_lastName: "Last name",
    admin_contactEmail: "Contact email",
    admin_phone: "Phone",
    admin_success: "Success",
    admin_userCreated: "New user was created",
    admin_sortBy: "Sort by",
    admin_sortByName: "Name",
    admin_sortByAdded: "Added",
    admin_sortByUpdated: "Updated",
    admin_sortByEmail: "Email",
    admin_sortByCreated: "Created",
    adminPanel: "Admin panel",
    admin_Add: "Add",
    admin_Places: "Places",
    admin_UnQuestions: "Unlinked questions",
    admin_ChooseYourPlace: "Select your business location",
    admin_NothingFound: "Nothing Found",
    admin_Delete: "Delete",
    admin_delete_image: "Do you want to delete this image?",
    admin_successImageDelete: "The image has been deleted",
    Track_vote: "To track your votes, please sign in:",
    Logout: "Logout",
    Sync_status: "Sync status",
    Success: "Success",
    Error: "Error",
    Back: "Back",
    Thank_for_vote: "Thank you for your vote. Want to track your votes? Sign in using",
    No_votes: "You don't have any votes yet",
    statusMessage: "Working...",
    Save: "Save",
    ResetChanges: "Reset changes",
    sign_in_to_connect: "Please sign in to connect this question to your business",
    yes: "Yes",
    no: "No",
    YourVotes: "Your votes",
    OtherVotes: "Other users' votes",
    AirVotes: "AirVotes",
    Change: "Change",
    Submit: "Submit",
    Cancel: "Cancel",
    CancelRequest: "Request has been canceled",
    ChangedYourMind: "Changed your mind? Select another vote!  Note the date/time will stay the same.",
    NotConnectedPlaceToAirVote: "This place is currently not connected to AirVote",
    From: "From",
    To: "To",
    writeFeedBack: "Add a comment (optional)",
    voteSuccessText_1: "Vote submitted, thanks!",
    voteSuccessText_2: "Want to change it? Just tap another smiley.",
    voteSuccessText_3: "Have something to say? Leave an optional note",
    feedbackTitle: "Add a note",
    feedbackTitleSoSo: "What could be better?",
    feedbackTitleSad: "What’s not right?",
    feedbackSubtitle: "Only a place owner sees it",
    yourNote: "Your note",
    commentPopupEmail: "Enter your email or phone",
    feedbackText: "I want to hear back on this",
    feedbackHelpText: "Place owner will receive it to get in touch with you",
    writeAReview: "Write a review",
    writeAReviewTitle: "You can write a review for {v1} here:",
    bflow_BusinesConnectQuestion: "Please choose your business to connect the question \"{v1}\"",
    bflow_BusinesConnectQuestionSuccess: "Question was linked successfully",
    bflow_ChoosePlace: "Please choose a place to connect the question \"{v1}\"",
    bflow_AddQuestionSuccess: "Question added",
    bflow_BecameOwnerPlace: "Done. You are now a designated contact for \"{v1}\"",
    bflow_BecameOwnerPlaceConfirm: "List you as the designated contact for  \"{v1}\" ?",
    bflow_ConfirmConnectQuestionToPlace: "Add question \"{v1}\" to this location \"{v2}\" ?",
    bflow_ConfirmConnectQuestionToPlacebelow: "Add question \"{v1}\" to below location ?",
    bflow_ConnectedQuestion: "Connecting question...",
    bflow_finishBusinesFlow: "Do you want do exit?",
    bi_Name: "Name",
    bi_OfficialName: "Official name",
    bi_ContactEmail: "Contact email",
    bi_Phone: "Phone",
    bi_Password: "Password",
    bi_Edit: "Edit",
    bi_Address: "Address",
    bi_WebsiteUrl: "Website url",
    bi_validation_OrganizationRequired: "Organization name is required",
    bi_validation_Email: "Incorrect email format",
    bi_validation_Phone: "Incorrect phone format",
    bi_validation_Website: "Incorrect website format",
    bi_first_Name: "First name",
    bi_last_Name: "Last name",
    own_anyConnectedPlace: "No business site connected yet",
    bi_confirm_email: "Email address not confirmed",
    bi_resend_email: "Resend autorization email",
    bi_resend_email_success: "Confirmation email has been resent successfully",
    bi_change_password: "Change your password",
    bi_set_password: "Set password",
    bi_cancel_password: "Cancel password change",
    bi_current_password: "Current password",
    bi_retype_password: "Reenter new password",
    bi_new_password: "New password",
    bi_save_password: "Save new password",
    bi_password_change_success: "Password was changed successfully",
    bi_confirm_new_password: "Confirm Password",
    own_use_w3w: "Use what3words for geolocation",
    own_email_Confim: "Please confirm your email address",
    own_myQuestions: "My questions",
    own_createQuestion: "Create question",
    own_orderStickers: "Order QR smileys",
    own_selectRange: "Select range",
    own_today: "Today",
    own_last7days: "Last 7 days",
    own_lastMonth: "Last month",
    own_allTime: "All time",
    own_custom: "Custom",
    own_Search: "Search",
    own_showMore: "Show more",
    own_showLess: "Show less",
    own_Locations: "Placements",
    own_Questions: "Questions",
    own_Total: "Total",
    own_Happy: "Happy",
    own_SoSo: "So-so",
    own_Sad: "Sad",
    own_green: "Green",
    own_yellow: "Yellow",
    own_red: "Red",
    own_EditQuestion: "Edit question",
    own_DownloadPDF: "Generate QR smileys",
    own_DownloadPDFMobile: 'Generate QR',
    own_OrderSticker: "Order QR sticker",
    own_DeleteQuestion: "Delete question",
    own_DownloadAndPrint: "Download and Print",
    own_OrderStickerFrom: "Order QR smileys from AirVote",
    own_DeliveryAddress: "Enter delivery address",
    own_RecipientName: "Recipient's name",
    own_RecipientPhone: "Recipient's phone",
    own_RecipientEmail: "Recipient's email",
    own_Comment: "Comment",
    own_ShowZeroVotes: "Show zero votes",
    own_CreateNew: "Create a new AirVote question",
    own_EnterQuestion: "Enter your AirVote question here",
    own_SpecifyLocation: "Specify placement",
    own_DownloadPDF_Title: "Question added",
    own_DownloadPDF_Description: "You can now download a PDF of the question. To order one from AirVote® use \"Generate QR smileys\" item in a question menu",
    own_DownloadPDF_EditTitle: "Question updated.",
    own_SureTODelete: "Delete your question?",
    own_DownloadSticker: "Download QR smileys PDF",
    own_StickerProportion: "Select a smileys layout which matches your needs",
    own_PanelTextLeaflet: "Compact",
    own_PanelTextBusiness: "Business card",
    own_PanelTextExtended: "Standard",
    own_PanelSubtitleLeaflet: "Print as a small customer handout card or place it on the back of your business card",
    own_PanelSubtitleExtended: "Print on a sticker or poster. Place it within customer reach",
    own_PanelSubtitleBusiness: "More compact layout for the cases you need AirVote QR smileys to be printed and distributed as business cards",
    own_AllVotesWillDeleted: "All the votes for this AirVote® question will be deleted",
    own_HasBeenDeleted: "Question deleted",
    own_DontForgetCreate: "Don’t forget to create a new one!",
    own_Manage: "Manage",
    own_Title: "Welcome to AirVote business panel!",
    own_Business: "Your business",
    own_Subitle: " Provide the name of your business to be able to create questions. This can be changed\n" +
        "                        any time later",
    own_Address: "Address",
    own_map_Placement: "Placement",
    own_map_Sld: "Issue",
    own_map_Question: "ID",
    own_BusinessName: "Your business name",
    own_SaveBtn: "Save and continue",
    own_SaveBtnWithQuestion: "Save and get my QR smileys",
    own_CanNotFind: "Can not find my business",
    own_AssetId: "Asset ID",
    own_PleaseStartWriting: "Please start writing the name of your business and choose it from the dropdown",
    AnalyticSettings: "Analytics options",
    AnalyticDescription: "By configuring this you adjust the way data is displayed at the analytics dashboard",
    AnalyticIndex: "Preferred analytics index",
    AnalyticWhatMean: "What does this mean?",
    AnalyticWhatMeanIndex: "Why Index is a good idea?",
    AnalyticWhatMeanIndexDescription: "Index provides an objective measure to track the trends over time and compare performance across different areas",
    AnalyticWhatMeanIndexValue: "How does AirVote calculates Index values:",
    AnalyticIndexPromouterScore: "・Net Promoter Score: #”happy votes” * 100% + #”so-so” votes * 0% - #”sad” votes * 100%. The highest score is 100. The lowest score is -100.",
    AnalyticIndexAirVoteScore: "・AirVote Score: #”happy votes * 100% + #”so-so” votes * 50%. The highest score is 100. The lowest score is 0.",
    ThereIsAnError: "Please enter correct value",
    StickerStatus: "Sticker status",
    Requested: "Requested",
    Sent: "Sent",
    Cancelled: "Cancelled",
    Close: "Close",
    welcomeModalTitle: "Find your company on the map",
    welcomeModalSubtitle: "We use Google data to help you register your company in AirVote",
    welcomeModalSearchYouBusinass: "Search for your business using input on top of the screen",
    welcomeModalPickOnMap: "Or pick it on the map",
    welcomeModalNotOnGoogle: "Business not on Google? Issues? Write to us at",
    mapTipsSearch: "Search for your business by name",
    mapTipsPick: "Or pick it up on the map",
    OK: "OK",
    Location: "Placement",
    Question: "Question",
    thankVoteTitle1: "Feedback saved",
    thankVoteTitle2_1: "Thanks for voting",
    thankVoteTitle2_2: "Join AirVote so you can review and change your votes",
    companyManagement: "Company management",
    sites: "Business sites",
    site: "Site",
    SitesDescription: "Business sites are different branches or locations of your company. Each site can be assigned one or more site managers to co-administer the site's AirVote system.",
    addNewSite: "Add business site",
    siteDetail: "Site details",
    questionsAndAnalytics: "Questions and analytics",
    companyInformation: "Company information",
    companyManagers: "Company managers",
    saveChanges: "Save changes",
    companyManagersDescription: "You can assign other company managers to co-administer your company's AirVote system.",
    Invite: "Invite",
    EnterEmailToAssignCompanyManager: "Enter email to assign a company manager",
    enterSeveralEmailByComma: "You may enter several email separated by comma",
    Pending: "Pending",
    Accepted: "Accepted",
    Remove: "Remove",
    ActiveManagers: "Active managers",
    NoOthersCompanyManagersAssigned: "No others company managers assigned",
    removeManager: "Remove manager: {v1}?",
    all: "All",
    editManagers: "Edit managers",
    assignManagers: "Assign managers",
    viewAnalytic: "View analytics",
    deleteSite: "Delete site",
    deleteSiteConfirm: "Delete site: {v1}?",
    siteManagers: "Site managers",
    SiteManagersNotAssigned: "Not assigned",
    siteName: "Site name",
    siteAddress: "Your website or social media link",
    siteAddressSidebar: "Address",
    Website: "Website",
    Email: "Email",
    Alias: "Alias",
    EditPhoto: "Edit photo",
    SitePhoto: "Site photo",
    AirVoteSuggestsTitle: "AirVote suggests",
    SearchForQuestion: "Suggested questions",
    UseQuestion: "Use question",
    ImagesSupportedParams: "Images in PNG and JPG formats are supported. Maximum size of photo is 5 Mb",
    UploadFile: "Upload file",
    RemovePhoto: "Remove photo",
    ReturnBtn: "Back",
    RemovePhotoConfirm: "Remove site photo?",
    RemovePhotoSuccess: "Photo removed",
    WrongFormat: "Wrong format. Please use PNG or JPG",
    PhotoOverweight: "Photo is more than {v1}Mb",
    cancelInvite: "Cancel invite: {v1}?",
    createSiteMap: "Create a new site using this place: {v1}?",
    sendAlertEvery: "Send alert every",
    checkboxSoSo: "So-So",
    checkboxHappy: "Happy",
    checkboxSad: "Sad",
    chooseNewPlaceFrOrganization: "Please choose a new place for your organization.",
    MyBusinessIsMultipleSites: "My business has multiple sites",
    goingToMultipleSitesMode: "Request multiple site mode for your organization?",
    by_questions: "Questions",
    by_sites: "Sites",
    by_locations: "Placements",
    groupBy: "Group by",
    Diagram: "Diagram",
    ID: "ID",
    Filter: "Filter",
    Comments: "Comment",
    ownLastVotes: "Recent votes",
    IndexAirvote: "AirVote index",
    TotalVotes: "Total votes",
    Notifications: "Alerts",
    CloseAccount: "Close my account",
    DowngradeToClient: "Downgrade me to client",
    SendNotificationEach2: "votes",
    WithCommentsOnly: "typed comments/pictures/audio",
    WithDetailsOnly: "With details only",
    WithSldOnly: "standard problem selections",
    CommentsOnly: "Comments only",
    SMS: "SMS",
    Reports: "Reports",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    SendRequestToClose: "Сlose your account?",
    SendRequestToRestore: "Send Request to restore account?",
    RestoreAccount: "Restore account",
    DowngradeProfileToClient: "Downgrade profile to client role?",
    ProfileSettings: "Profile settings",
    savedSuccessfuly: "Settings saved successfully",
    Message: "Message",
    NoData: "No data",
    Decline: "Decline",
    Approve: "Approve",
    DeclineRequest: "Decline request to delete account?",
    ApproveRequest: "Approve request to delete account?",
    MyPlaces: "My places",
    EmptySiteTitle: "Your company doesn’t have any sites set up. Add one!",
    EmptySiteDescription: "Sites are different branches or offices of your company. Each site can be assigned one or more site admins. A Site admin can edit site details and have access to site analytics",
    accountSettings: "Account settings",
    accountSettingsDescription: "Modify your profile data, manage notifications and reports you receive",
    otherOptions: "Other options",
    UploadNewPhoto: "Upload new photo",
    receiveBadVotesViaSms: "You can receive notifications about votes via email or SMS",
    Threshold: "Threshold",
    SoSoVotes: "So-so votes",
    Channel: "Channel",
    DisableAllNotifications: "Disable all notifications",
    EnableAllNotifications: "Enable all notifications",
    sendDetailedReportToEmail: "We can send detailed reports to your email",
    Regularity: "Regularity",
    nothingSelected: "Nothing selected",
    allNotificationsDisabled: "All notifications disabled",
    createNewUser: "Create new user",
    exportRawData: "Export",
    exportTo: "Export to",
    w3wTitle: "Simple way to describe location anywhere in the world",
    w3wLearnMore: "Learn more",
    unassignedQuestion: "Hide unassigned questions",
    moreOptiosPopuoTitle: "More Options",
    driverMainText: "Your account {v1} has access only to manage placements and locations.\n" +
        "Use your management login to have full access to the {v2} dashboard",
    own_filter_placeholder: "Start typing to filter",
    own_ExtPlacementEdit: "Set",
    smileysMailTitle: "Your AirVote QR smileys are on the way!",
    smileysMailSubtitle: "Check {v1} for your QR smileys. If you do not receive them within a few minutes—please check your Spam folder or",
    smileysMailDownload: "download here",
    smileysMailChecklist: "You can now log in to your business panel. Use it to:",
    smileysMailChecklistFirst: "Check the real-time customer vote reports",
    smileysMailChecklistSecond: "Create and print additional questions",
    smileysMailChecklistThird: "Configure real-time alerts on problem areas",
    smileysMailChecklistFourth: "View advanced analytics",
    smileysMailChecklistMore: "...and much more!",
    smileysMailChecklistBtn: "Take me to my business panel now",
    smileysMailChecklistBack: "Back to website",
    signIn_enter: "Enter, using",
    signIn_or: "or",
    signIn_difficulties: "Having difficulties?",
    signIn_contact: "Contact us at",
    question_suggestions_freq_title: "Recently used",
    signIn_signIn_title: "Sign In",
    signIn_signUp_title: "Register",
    signIn_enter_using_email: "or enter using your email",
    signIn_email_hint: "Email address",
    signIn_password_hint: "Password",
    signIn_signInBtn: "Sign In",
    signIn_forgotPass_btn: "Forgot a password?",
    signIn_noCreditReq: "No credit card required",
    signIn_firstName_hint: "First name",
    signIn_lastName_hint: "Last name",
    signIn_signUp_btn: "Register",
    signIn_useMedia: "Or sign up using social media",
    signIn_agreeTo: "I agree to AirVote",
    signIn_tAndC: "Terms and Conditions",
    signIn_recoverPassword: "Recover your password",
    signIn_recoverPassSubtitle: "Enter the email used for sign in to your account",
    signIn_recoverPassContinue: "Continue",
    signIn_recoverPassBack: "Back to Sign in",
    signIn_codeAlreadyUsed: "This reset password code is already used",
    signIn_protected: "This site is protected by reCAPTCHA and the Google",
    signIn_privacyPolice: "Privacy Policy",
    signIn_and: "and",
    signIn_Terms: "Terms of Service",
    signIn_Login: "Sign in using {v1}",
    signIn_Register: "Register using {v1}",
    signIn_RegisterWithEmail: "Register with email address",
    signIn_RegisterWithQuestion: "Next: About my business",
    signIn_SeparatorText: "OR",
    signIn_TitleWithQuestion: "Register with AirVote to:",
    signIn_ChecklistFirst: "Receive your QR smileys by email",
    signIn_ChecklistSecond: "Access your business panel to track responses (votes)",
    signIn_LookAtEmail: "Please check your email for further instructions",
    resetPasswordRequestCancel: "Your password reset request was cancelled",
    resetPasswordRequestAlreadyCanceled: "Your password reset is already cancelled",
    changePasswordFormTitle: "Change Password",
    passwordDontMatch: "Passwords don't match",
    auth_confirm_email_confirming: "Confirming your email 🔄",
    auth_confirm_email_confirmed: "Email confirmed successfully ✅\nRedirecting to the business panel...",
    auth_confirm_email_already_confirm: "Your email was already confirmed",
    login_btn_link: "Login",
    login_btn_text: "to your business dashboard",
    giveawayBottom_title: 'Tap to participate in our gift card drawing!',
    giveawayBottomFinish_title: 'You were added to gift card drawing!',
    giveawayPopup_title: 'PARTICIPATE IN A GIFT CARD DRAWING',
    giveawayPopup_login: 'Log in to Google or Facebook',
    giveawayPopup_review: 'Leave a review at any of {v1}`s pages',
    giveawayPopup_entered: 'You will be entered into',
    giveawayPopup_BtnLogin: 'Start by logging in',
    giveawayPopup_BtnReview: 'Leave a review',
    giveawayPopup_cancel: 'I do not want to participate',
    giveawayPopup_finalStep: 'We appreciate your honest review!\n\nYou have been added to our giveaway drawing.\n\nCome back and vote again: every vote will increase your chances!',
    giveawayPopup_proceedReview: "Proceed to submit a review",
    password_validation_min_length: "Min 6 chars length",
    password_validation_uppercase: "One uppercase letter",
    password_validation_lowercase: "One lowercase letter",
    loadPdfProgress: "Please wait until your PDF is generating 🔄",
    showManagePopupTitle: "Manage questions, download QR smileys",
    showManagePopupSubtitle: "Welcome to the AirVote business panel! Every block you see on the screen is a question you’ve set up. Use the icon to manage questions: edit, remove or download QR smileys as PDF",
    showFeedbackPopupTitle: "Start getting feedback",
    showFeedbackPopupSubtitle: "When you have your QR smileys printed, place them in a spot to be seen by the customer. Every vote is immediately displayed in your business panel",
    showAlertsPopupTitle: "Set up and receive alerts",
    showAlertsPopupSubtitle: "Congratulations with getting your first votes! Do you know that you can receive notifications about any vote on your mobile or email? Use your profile page to set up notification rules",
    helpCenterTitle: "Help center",
    dataReportPopup: 'There is no data. Please change your filters or choose a different date range',
    dataReportPopupMobileXLSX: 'This file will only contain raw data. For the detailed vote analytics and charts, please use AirVote dashboard on PC or Mac',
    unsubscribeBtn: "Unsubscribe",
    unsubscribeSaveBtn: "Update settings",
    unsubscribePopupText: "Unsubscribed successfully",
    orderBannerSubtitle: "We can print out your questions on a waterproof vinyl and send anywhere in the world",
    orderBannerBtn: "Order stickers",
    orderStickersBtn: "Order QR stickers",
    orderPageBtn: "Let’s get started",
    orderSelectTitle: " Select questions you would like to print",
    orderBusinessSite: 'Business site',
    orderBusinessPlacement: 'Placement',
    orderTotal: 'Order total',
    orderDelivery: 'Shipping',
    orderShippingBlockTitle: 'Delivery information',
    orderDeliveryText: 'Free',
    orderFormTitle: 'Complete your order',
    orderFormSubtitle: 'Approximate delivery time is 10—15 days',
    orderShippingTitle: 'Shipping outside United States or Europe',
    orderShippingSubtitle: 'Contact AirVote to get the order quote including all the shipping and customs fees',
    orderQuote: 'Get a quote',
    orderSuccessPayment: 'Your order was successfully created. We will contact you soon to provide a quote',
    orderSuccessPayPal: 'Your order was successfully paid. You will be notified when the order is shipped',
    orderBtnToDashboard: 'Go to the dashboard',
    orderCountryLabel: 'Country',
    orderStickerSizeLabel: 'Sticker size',
    own_votesNotFound: 'Seems like you don\'t have any recent votes 😔\n\nPlease make sure your AirVote Stickers are still on their places and work correctly',
    own_votesQuestion: 'Question:',
    own_votesPlacement: 'Placement:',
    own_votesPriorVotes: 'User\'s prior votes:',
    own_votesUser: 'User:',
    own_votesComment: 'Comment:',
    own_votesContactInfo: 'Contact info:',
    bulkPlacement: 'Bulk placement edit',
    bulkPlacementPopupSavedQuestions: 'Selected questions',
    bulkPlacementPopupSelectAll: "Select all",
    bulkSuccessfulPlaceEdit: "Placement was changed successfully",
    bulkInputPlaceHolder: "New placement",
    manageNotEnoughPermissions: "You don't have enough permissions to manage this AirVote question. Please sign in using a different account or ask for a permission",
    showAllVotes: "Show all recent votes",
    setupTelegramBtn: "Setup Telegram Bot",
    copy: "Copy",
    telegramPopupGroup: "Add Bot to the group",
    telegramPopupPrivate: "Add Bot to the private chat",
    telegramPopupTitle: "Your Hash",
    telegramHashAvailable: "Current hash is available for 1 hour",
    emailSignature: 'Electronic Communications',
    emailSignatureSubtitle: "Copy/paste the smileys into your emails, electronic invoices or for any online presentations",
    emailSignatureTitle: 'How’s AirVote working for you so far?',
    emailSignatureClick: 'Click on a smiley to leave your feedback',
    emailSignatureCopyLink: 'Copy link',
    singleEmailSignaturePageTitle: 'Add AirVote E-Smiley to you Communications',
    copied: 'Copied',
    tab_Map: "Map",
    airLeads: 'AirLeads',
    serviceLogs: 'Service logs',
    serviceLog: 'Service Log',
    airLeadSubmittedBy: 'Submitted By:',
    airLeadChooseDriver: 'choose driver',
    airLeadCompanyName: 'Company name',
    airLeadSiteType: 'Site type',
    airLeadOpportunity: 'Opportunity',
    airLeadCustomer: 'Customer',
    airLeadAdditionalNotes: 'Additional notes',
    airLeadMoreService: 'More service',
    airLeadMoreUnits: 'More Sanitary Restrooms',
    airLeadSink: 'Handwash/Hand Sanitizer Station',
    airLeadCallThem: 'To call them',
    airLeadSubmitALead: 'Submit a lead',
    airLeadHideLeads: 'Hide closed leads',
    airLeadShowAllLeads: 'Show all leads',
    airLeadDashboardDate: 'Date',
    airLeadDashboardType: 'Type',
    airLeadDashboardStatus: 'Status',
    airLeadDashboardStatusNotes: 'Status notes',
    airLeadDashboardLastActionDate: 'Last action date',
    airLeadDashboardActionBy: 'Action by',
    airLeadDashboardSalesFollowUp: 'Sales followup',
    airLeadDashboardNotClosed: 'Not closed',
    airLeadDashboardClosedWon: 'Closed/Won',
    airLeadDashboardNotQualified: 'Not qualified',
    airLeadDashboardCommission: 'Commission',
    airLeadDashboardQuantity: 'Quantity',
    airLeadDashboardNotLeadsFound: 'No leads found',
    airLeadDashboardRefresh: 'Refresh',
    airLeadInfoPopupDriver: 'Driver',
    airLeadInfoPopupNotes: 'Notes',
    airLeadInfoPopupLocation: 'Location',
    airLeadInfoPopupViewOnMap: 'View on map',
    airLeadInfoPopupServices: 'Services',
    airLeadStatusAndCommissionError: 'Please enter Status notes and Commission to close a lead',
    airLeadStatusNotesError: 'Please enter Status notes to close a lead',
    airLeadNewCustomerLead: 'New Customer Lead',
    airLeadExistingCustomer: 'Existing Customer Lead',
    airLeadPleaseChooseDriver: 'Please choose a driver',
    airLeadPleaseCompanyInfo: 'Please enter company information',
    airLeadPleaseCustomerInfo: 'Please enter customer information',
    airLeadGoodLack: 'Good luck on your lead! \nThanks for helping bring new customers!',
    airLeadCommission: 'Commission should be greater that 0',
    airLeadNumberShouldContains: 'Number should contain less than 3 digits',
    sldPlaceGuid: 'Place guid',
    sldOrganizationGuid: 'Organization guid',
    sldGetPlaceConfig: 'Reload config',
    sldEnableDetails: 'Enable 2d level details',
    sldDef_PortableRestrooms: 'Portable 🚾',
    sldDef_PublicRestrooms: 'Public 🚾',
    sldDef_Healthcare: 'Healthcare',
    sldBasicConfig: 'Basic config',
    sldScreenTitle: 'Screen title',
    sldScreenSubTitle: 'Screen subtitle',
    sldScreenBackground: 'Screen background:',
    sldMaxCount: 'Max count of selected items',
    sldEnterForUnlimited: 'Enter 0 for unlimited',
    sldShowComment: 'Show comment always',
    sldBlocks: 'Blocks:',
    sldText: 'Text',
    sldGreenScreen: 'Green screen',
    sldYellowScreen: 'Yellow screen',
    sldRedScreen: 'Red screen',
    sldOverrideSettings: 'Override basic settings',
    sldOverrideBlocks: 'Override basic blocks',
    sldSecondLevelDetails: 'Second Level Details',
    configMissingMsg: 'The config is missing, do you want to enable it?',
    sldTakeFromPlace: 'Take from place',
    sldChooseAnIcon: 'Choose an icon',
    sldEditIcon: 'Edit icon',
    sldUploadIcon: 'Upload new Icon',
    sldIconTag: 'Icon tag',
    sldPleaseFillInput: 'Please complete the field',
    sldDefaultText: 'Default text',
    sldChooseIcon: 'Please choose icon',
    sldSaveAndAddMore: 'Save and add more',
    sldAddIcon: 'Add icon',
    sldAreYouSure: "Are you sure to delete this image?",
    commentViewOnMap: 'View on map',
    serviceLogsDashboardNoLogsFound: 'No logs found',
    serviceLogsDashboardClearDateRange: 'Reset date range',
    serviceLogsDashboardClearFilters: 'Reset filters',
    serviceLogsDate: 'Date',
    serviceLogsStickerId: 'ID',
    serviceLogsAssetId: 'Asset ID',
    serviceLogsLocation: 'Location',
    serviceLogsGPS: 'GPS',
    serviceLogsServices: 'Services',
    serviceLogsData: 'Data',
    serviceLogsComments: 'Comments',
    serviceLogsPictures: 'Pictures',
    serviceLogsAudio: 'Audio',
    serviceLogsUser: 'User',
    enableServiceLog: 'Enable service log config',
    serviceLogForce: 'Force service log',
    serviceLogRequirePin: 'Require pin',
    serviceLogInfoPopup: 'Show Service log info popup',
    serviceLogPlacementEdit : 'Show placement edit',
    own_limitedAccessDialogTitle: "Limited access",
    own_limitedAccessDialogBody: "You\'ve reached your free monthly votes limit. Votes hidden: {v1}.\nTo get full access please contact AirVote team",
    own_limitedAccessDialogContactBtn: "Contact Team",
    own_limitedAccessText: "You\'ve reached your free monthly votes limit. Votes hidden: {v1}.\nTo get full access please contact AirVote team: {v2}",
    settings_integrations: "Integrations",
    settings_link_cro: "Link CRO",
    settings_unlink_cro: "Unlink CRO",
    settings_unlink_cro_success: "CRO account was successfully unlinked",
    settings_link_hubspot: "Link Hubspot",
    settings_unlink_hubspot: "Unlink Hubspot",
    settings_unlink_hubspot_success: "Hubspot account was successfully unlinked",
    auth_cro_progress: "Authorization in progress 🔄",
    auth_cro_done: "Authorization successful ✅\nRedirecting to the business panel...",
    auth_cro_error: "Oops... Something went wrong\nPlease try again or contact support.",
    auth_hubspot_progress: "Authorization in progress 🔄",
    auth_hubspot_done: "Authorization successful ✅\nRedirecting to the business panel...",
    auth_hubspot_error: "Oops... Something went wrong\nPlease try again or contact support.",
    sldTagInUseErrorTitle: "Unable to do this action. Tag is currently in use:",
    serviceRequest_pickupTitle: "Dumpster Pickup Request",
    serviceRequest_swapTitle: "Dumpster Swap Request",
    serviceRequest_pickupNotesHint: "Pickup notes",
    serviceRequest_swapNotesHint: "Dumpster swap notes",
    serviceRequest_defNotesHint: "Notes",
    serviceRequest_nameHint: "Name*",
    serviceRequest_phoneHint: "Phone number*",
    serviceRequest_pickupSendBtnText: "Confirm pickup request",
    serviceRequest_swapSendBtnText: "Confirm swap request",
    serviceRequest_defSendBtnText: "Request",
    serviceRequest_swapRequiredCbLbl: "Confirm charge for swap on account*",
    serviceRequest_successText: "Your request has been sent",
    tab_AssetsMap: "Assets map",
    settings_checkbox_GoogleReviewAlerts: "Google review alerts",
    level2_maxCount: "Maximum number of items to choose: {v1}",
    saving: "Saving",
}
